import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import CardActionArea from '@mui/material/CardActionArea';
import CardActions from '@mui/material/CardActions';
import Grid from '@mui/material/Grid';
import Badge from '@mui/material/Badge';
import RideBookingForm from '../dashboard/RideBookingForm'
import Modal from '../modal/modal';
import { CommonContext } from '../modal/Context';

import Carousel from 'react-bootstrap/Carousel';
import { useContext } from 'react';
export default function MultiActionAreaCard() {


  

  const { welcomeModal, setWelcomeModal ,rideBookingModal,setRideBookingModal} = useContext(CommonContext);

  const carList = [
    {
      name: 'SVR Taxi - Traveller',
      rentPerHour: 30,
      waitingCharge: 5,
      imageUrl: '/images/login/mini_omini.webp',
    },
    {
      name: 'SVR Taxi - INNOVA',
      rentPerHour: 50,
      waitingCharge: 10,
      imageUrl: '/images/login/toyoto_8Seater.jpg',
    },
    {
      name: 'SVR Taxi - ECCO',
      rentPerHour: 50,
      waitingCharge: 10,
      imageUrl: '/images/login/palani_trip_toyoto_5.webp',
    }
    // Add more car details as needed
  ];

  
  const [ openRideBooking, setOpenRideBooking ] = React.useState(false);
  const [isMobile, setIsMobile] = React.useState(false);

  
  const checkDeviceWidth = () => {
    // You can adjust the width breakpoint as needed
    if (window.innerWidth >= 768) {
      setIsMobile(false); 
      } else {
      setIsMobile(window.innerWidth <= 768); 
      // Open the drawer on tablets and laptops
      // Keep the drawer closed on mobile devices
    }
  };

  React.useEffect(() => {
    // Set initial drawer state based on device width
    checkDeviceWidth();

    // Add resize event listener to handle screen resizing
    window.addEventListener('resize', checkDeviceWidth);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener('resize', checkDeviceWidth);
    };
  }, []);

  const openBookingModal = () =>{
    if(!rideBookingModal){
      setRideBookingModal(true);
    }

  }

  React.useEffect(() => {
    if (rideBookingModal) {
      // Perform an action when the modal is open
      console.log('Ride booking modal is now open!');
      // You can trigger other actions or side effects here
    }
  }, [rideBookingModal]); 

  

  return (


    <Grid container spacing={2}>
    {rideBookingModal && (
      <Modal heading={''} action={rideBookingModal}>
        <RideBookingForm />
      </Modal>
    )}

    {/* Carousel Section */}
    <Grid xs={12} style={{marginLeft:'20px'}}>
      <Carousel style={{width:'100%'}} indicators={false} controls={true}>
        {carList.map((car, index) => (
          <Carousel.Item key={index}>
            <Card
              sx={{
                backgroundColor: 'white',
                width: '100%',
              }}
            >
             
              <CardMedia
                component="img"
                image={car.imageUrl}
                alt={car.name}
                sx={{ height: '100%',width: '100%' }}
              />
              <CardContent>
                <Typography variant="h5" component="div" sx={{ mb: 2 }}>
                  {car.name}
                </Typography>
                <Typography variant="body1">
                  Rent per hour: <strong>₹{car.rentPerHour}</strong>
                </Typography>
                <Typography variant="body1">
                  Waiting charge: <strong>₹{car.waitingCharge}/hour</strong>
                </Typography>
              </CardContent>
              <CardActions>
                <Button
                  variant="contained"
                  color="primary"
                  sx={{ width: '100%' }}
                  onClick={openBookingModal}
                >
                  Book
                </Button>
              </CardActions>
            </Card>
          </Carousel.Item>
        ))}
      </Carousel>
    </Grid>
  </Grid>


      );
}
